import * as React from "react";
import { leftBracket, rightBracket } from "../formatting.js";
export function BinTable({ bins, decimals }) {
    const scale = React.useMemo(() => {
        const max = Math.max(...bins.map(b => b.relFrequency));
        return 100 / max;
    }, [bins]);
    return (React.createElement("table", { id: "frequencyTable" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, "T\u0159\u00EDda"),
                React.createElement("th", null, "St\u0159ed"),
                React.createElement("th", null, "Abs. \u010Detnost"),
                React.createElement("th", null),
                React.createElement("th", null, "Rel. \u010Detnost"),
                React.createElement("th", null, "Rel. \u010Detnost / jednotka"))),
        React.createElement("tbody", null, bins.map((bin, index, array) => {
            return (React.createElement("tr", { key: bin.centre },
                React.createElement("td", null,
                    leftBracket(bin.leftClosed),
                    bin.left.toFixed(decimals),
                    " ; ",
                    bin.right.toFixed(decimals),
                    rightBracket(bin.rightClosed)),
                React.createElement("td", null, bin.centre.toFixed(decimals)),
                React.createElement("td", null, bin.frequency),
                React.createElement("td", null,
                    React.createElement("div", { className: "freqIndicatorDiv", style: { width: bin.relFrequency * scale } })),
                React.createElement("td", null, bin.relFrequency.toFixed(3)),
                React.createElement("td", null, bin.relFrequencyPerUnit.toFixed(3))));
        }))));
}
//# sourceMappingURL=BinTable.js.map